import { AnnotationOptions } from "chartjs-plugin-annotation";
import { MonitoringGraphData } from "@services/monitoring/types";

const MIN_INTERVAL = 10;

// not to draw too small noDataBoxes
const isIntervalLong = (currentX: number, xMin: number) =>
  currentX - xMin > MIN_INTERVAL;

const isYNullAtIndex = (datasets: MonitoringGraphData[], index: number) =>
  datasets.every(
    (dataset) =>
      dataset.data?.[index] &&
      dataset.data?.[index].length > 1 &&
      dataset.data?.[index][1] === null
  );

const createNoDataBox = (
  id: number,
  xMin: number,
  xMax: number
): AnnotationOptions => ({
  type: "box",
  backgroundColor: "rgba(200, 200, 200, 0.25)",
  borderColor: "transparent",
  id: String(id),
  xMin,
  xMax,
});

export const getNoDataBoxes = (datasets: MonitoringGraphData[]) => {
  const noDataBoxes: AnnotationOptions[] = [];
  const dataLength = datasets[0]?.data?.length;

  if (!dataLength) return noDataBoxes;

  let boxId = 1;
  let xMin = null; // noDataBox start

  const firstDataSet = datasets[0].data ?? [];

  for (let index = 0; index < dataLength; index++) {
    const xValue = firstDataSet[index][0]; // x value the same across datasets;
    const isYNull = isYNullAtIndex(datasets, index);

    if (isYNull && !xMin) {
      xMin = xValue;
    }

    if (!isYNull && xMin) {
      if (isIntervalLong(xValue, xMin)) {
        noDataBoxes.push(createNoDataBox(boxId, xMin, xValue));

        boxId++;
      }

      xMin = null;
    }
  }

  // If the last interval reaches the end of the dataset
  const lastXValue = firstDataSet[dataLength - 1][0];

  if (xMin && isIntervalLong(lastXValue, xMin)) {
    noDataBoxes.push(createNoDataBox(boxId, xMin, lastXValue));
  }

  return noDataBoxes.reduce<Record<string, AnnotationOptions>>(
    (acc, boxAnnotation, index) => {
      acc[`box-${index}`] = boxAnnotation;

      return acc;
    },
    {}
  );
};
